module.exports = __webpack_public_path__ + "static/media/user-big.8d6da29a.svg";